
interface ModalCloseButtonProps {    
    setOpenModal: (value: boolean) => void
}

const ModalCloseButton = ({setOpenModal}: ModalCloseButtonProps) => {
    return (
        <button
            aria-label="Close"
            className="absolute top-2 right-2  z-20 ml-auto inline-flex items-center rounded-lg bg-white border-gray-500 border-solid border-2 p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
            type="button"
            onClick={() => setOpenModal(false)}
        >
            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
    )
}

export default ModalCloseButton;